interface StepIndicatorProps {
  activeStep: number;
  onStepClick: (step: number) => void;
}

const steps = [
  { step: 1, label: '基础信息' },
  { step: 2, label: '内容上传' },
  { step: 3, label: '剧集详情' },
  { step: 4, label: '版权证明' },
  { step: 5, label: '商业模式' },
  { step: 6, label: '演员与确认' },
];

export default function StepIndicator({ activeStep, onStepClick }: StepIndicatorProps) {
  return (
    <div className="sticky top-14 sm:top-16 z-30 bg-white/95 backdrop-blur-sm border-b border-gray-200/70 shadow-2xs transition-all">
      <div className="w-full max-w-[1400px] mx-auto px-6 md:px-12 py-4">
        <div className="flex items-center justify-between">
          {steps.map((item, idx) => {
            const isCurrent = idx === activeStep;
            const isCompleted = idx < activeStep;

            return (
              <div key={idx} className="flex items-center flex-1 last:flex-initial">
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    onStepClick(idx);
                  }}
                  className="flex items-center gap-2.5 group cursor-pointer text-left focus:outline-none"
                >
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all shrink-0 ${
                      isCurrent
                        ? 'bg-primary-500 text-foreground-950 ring-4 ring-primary-100 shadow-xs'
                        : isCompleted
                        ? 'bg-emerald-500 text-white'
                        : 'bg-gray-100 text-gray-400 border border-gray-200'
                    }`}
                  >
                    {isCompleted ? <i className="ri-check-line text-base"></i> : item.step}
                  </div>
                  <span
                    className={`text-sm md:text-base whitespace-nowrap transition-colors ${
                      isCurrent
                        ? 'text-foreground-950 font-bold'
                        : isCompleted
                        ? 'text-foreground-700 font-medium'
                        : 'text-foreground-400'
                    }`}
                  >
                    {item.label}
                  </span>
                </button>
                {idx < steps.length - 1 && (
                  <div
                    className={`flex-1 mx-2 md:mx-4 h-0.5 transition-colors ${
                      isCompleted ? 'bg-emerald-500' : 'bg-gray-200'
                    }`}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}